<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      @if(srDetailLoading){
      <app-skeleton-loader
        [formLoader]="true"
        [noOfFields]="6"
      ></app-skeleton-loader>
      } @if(!srDetailLoading){
      <!-- Action for show notes -->
      @if (srNumber && srInprgoressAwating) {
      <app-validation-message
        type="info"
        [content]="{
          title: 'SECTION_NOTES' | translate,
          message: 'SECTION_NOTES_DESCRIPTION' | translate
        }"
        [showbutton]="false"
        [buttonText]="'VIEW_NOTES' | translate"
        (onBtnClick)="showNotes = true"
      />
      }
      <form [formGroup]="form">
        @if (isDocumentService || isVerifySignService) {
        <section>
          <h1 class="section-heading">
            {{ "ATTESTATION.UPLOAD_TITLE" | translate }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-option-field
                [label]="'ATTESTATION.DOC_TYPE' | translate"
                [control]="form.get('documentType')!"
                [options]="documentTypes"
                (onSelectionChange)="onDocumentTypeChange($event)"
              ></app-option-field>
            </div>
            @if (form.get('documentType')?.value ==
            fieldValueConstant.ATTESTATION_DOCUMENT_TYPE_OTHER
            ||form.get('documentType')?.value ==
            fieldValueConstant.ATTESTATION_DOCUMENT_TYPE_OTHER_AR) {
            <div class="field-control">
              <app-text-field
                [label]="'ATTESTATION.DOC_TYPE_OTHER' | translate"
                [control]="form.get('otherDocumentName')!"
                [maxlength]="150"
              />
            </div>
            } @if (isDocumentService) {
            <div class="field-control">
              <app-option-field
                [label]="'ATTESTATION.GOV_ENTITY' | translate"
                [options]="govEntities"
                [control]="form.get('govEntity')!"
              ></app-option-field>
            </div>
            } @if (isVerifySignService && form.get('documentType')?.value ==
            fieldValueConstant.ATTESTATION_DOCUMENT_TYPE_INV_COO ||
            form.get('documentType')?.value ==
            fieldValueConstant.ATTESTATION_DOCUMENT_TYPE_INV_COO_AR) {
            <div class="field-control">
              <app-text-field
                [label]="'ATTESTATION.COO_NUMBER' | translate"
                [control]="form.get('cooNumber')!"
                [maxlength]="50"
                (blur)="getListOfCOO()"
              />
            </div>

            @if ( showCooNumberError) {
            <app-validation-message
              [content]="{
                title: 'ALERT.NO_RESULTS_TITLE' | translate,
                message: 'ALERT.CORRECT_COO_NUMBER' | translate
              }"
              type="error"
            />
            }

            <div class="field-control">
              <app-option-field
                [label]="'ATTESTATION.ATTESTATION_TYPE' | translate"
                [control]="form.get('attestationType')!"
                [lovType]="lookupKey.COO_STAMP_TYP"
              ></app-option-field>
            </div>
            } @if(loadingDoc){
            <app-skeleton-loader
              [formLoader]="true"
              [noOfFields]="3"
            ></app-skeleton-loader>
            } @if (srFolder && !loadingDoc) { @for (dt of
            srFolder.allowedDocumentTypes; track $index) {
            <div class="field-control">
              <app-file
                #fileCmp
                [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                [control]=""
                [documentType]="dt.nameEn"
                (folderMissing)="openFolder()"
                (onUploadRemove)="handelFileEvent($event, dt.nameEn)"
                [showAction]="showActions"
                [folder]="srFolder"
                [documentServiceType]="documentServiceType.ATTESTATION"
                [svsSubject]="svsSubject"
                [stampLocationRequirement]="
                  dt?.stampLocationRequirement || 'NOT_APPLICABLE'
                "
              ></app-file>
            </div>
            } }
          </div>
        </section>
        }

        <!-- certify document /true copy -->
        @if (isCertifyService) {
        <section>
          <h1 class="section-heading">
            {{ "ATTESTATION.SELECT_DCOUMENT" | translate }}
          </h1>
          <p class="px-2 text-sm text-gray-100 mb-4">
            {{ "ATTESTATION.SUBJECT_DESC" | translate }}
          </p>
          <div class="fields-container">
            <div class="field-control">
              <div class="fields-error-container">
                @if (form.get('subjectType')?.touched &&
                form.get('subjectType')?.invalid) {
                {{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}
                }
              </div>
              <div class="space-y-2">
                @for (subject of documentTypes; track subject) {
                <div>
                  <div
                    class="card-edge-cut relative border-blue subject-option-card"
                    [ngClass]="{
                      'subject-option-card-selected':
                        form.get('subjectType')?.value === subject.Value
                    }"
                  >
                    <div class="card-body h-full flex flex-col">
                      <div class="flex gap-5">
                        <input
                          type="radio"
                          [value]="subject.Value"
                          formControlName="subjectType"
                          class="h-5 w-5 text-dc-navy border-gray-300 accent-dc-navy mt-1"
                        />
                        <div class="text-dc-navy!">
                          <span class="font-semibold">{{ subject.Value }}</span>
                          <!-- <p class="text-dc-navy! py-2">
                              {{ subject.Description }}
                            </p> -->
                          @if(subject?.uploadedDate || subject?.documentId ||
                          subject?.certificateUrl){ @if(subject?.documentId){
                          <p class="text-dc-navy! py-2">
                            {{
                              "ATTESTATION.UPLOADED"
                                | translate
                                  : {
                                      date:
                                        (subject?.uploadedDate
                                        | date : "dd MMMM yyyy")
                                    }
                            }}
                          </p>
                          <a
                            class="text-dc-navy! py-2 underline underline-offset-4"
                            role="button"
                            (click)="downloadMappedDocument(subject)"
                            [class.pointer-events-none]="
                              downloadingDocId === subject?.documentId
                            "
                            [class.opacity-60]="
                              downloadingDocId === subject?.documentId
                            "
                            >{{ "ATTESTATION.VIEW_DOC" | translate }}</a
                          >
                          } @if(subject?.certificateUrl){
                          <p class="text-dc-navy! py-2">
                            {{
                              "ATTESTATION.UPLOADED"
                                | translate
                                  : {
                                      date:
                                        (subject?.uploadedDate
                                        | date : "dd MMMM yyyy")
                                    }
                            }}
                          </p>
                          <a
                            class="text-dc-navy! py-2 underline underline-offset-4"
                            role="button"
                            (click)="
                              downloadCertificate(subject?.certificateUrl)
                            "
                            [class.pointer-events-none]="
                              downloadingDocId === subject?.certificateUrl
                            "
                            [class.opacity-60]="
                              downloadingDocId === subject?.certificateUrl
                            "
                            >{{ "ATTESTATION.VIEW_DOC" | translate }}</a
                          >
                          } }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>

            @if (!shouldHideDocumentsSection) {
            <div class="field-control">
              @if(loadingDoc){
              <app-skeleton-loader
                [formLoader]="true"
                [noOfFields]="3"
              ></app-skeleton-loader>
              } @if (srFolder && !loadingDoc) { @for (dt of
              srFolder.allowedDocumentTypes; track $index) {
              <div class="field-control">
                <app-file
                  #fileCmp
                  [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                  [control]=""
                  [documentType]="dt.nameEn"
                  (folderMissing)="openFolder()"
                  (onUploadRemove)="handelFileEvent($event, dt.nameEn)"
                  [showAction]="showActions"
                  [folder]="srFolder"
                  [documentServiceType]="documentServiceType.ATTESTATION"
                  [svsSubject]="svsSubject"
                ></app-file>
              </div>
              } }
            </div>
            }
          </div>
        </section>
        }

        <!-- Verify signature -->
        @if (isVerifySignService) {
        <section>
          <h1 class="section-heading">
            {{ "ATTESTATION.SIGNATORY_TITLE" | translate }}
          </h1>
          <p class="text-sm text-gray-100 mb-4 px-2">
            {{ "ATTESTATION.SELECT_SIGNATORY_DESC" | translate }}
          </p>
          <div class="fields-container">
            @if(userType != userTypeValue.MEMBER && userType !=
            userTypeValue.MEMBER_AR){
            <div class="field-control">
              <app-text-field
                [label]="'ATTESTATION.MEMBER_NUMBER' | translate"
                [control]="form.get('memberNumber')!"
                [maxlength]="15"
                (blur)="getMemberSignatory()"
              />
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'ATTESTATION.MEMBER_NAME' | translate"
                [control]="form.get('memberName')!"
              />
            </div>
            <!-- @if (showActions) {
            <div class="buttons-group">
              <app-button
                [type]="'button'"
                [label]="'BUTTONS.CHECK_DETAIL' | translate"
                classesName="card-edge-cut-white btn-edge-cut"
                (onBtnClick)="getMemberSignatory()"
              />
            </div>
            }  -->

            } @if(!singatoryList || (form.get('memberNumber')?.value &&
            singatoryList.length < 1)){
            <div class="field-control">
              <app-validation-message
                type="error"
                [content]="{
                  title: 'ATTESTATION.SIGNATORY_NOT_FOUND' | translate,
                  message: 'ATTESTATION.SIGNATORY_NOT_FOUND_MSG' | translate
                }"
              ></app-validation-message>
            </div>
            } @if(singatoryList && singatoryList.length > 0){
            <div class="field-control">
              <label class="field-label">{{
                "ATTESTATION.SELECT_SIGNATORY" | translate
              }}</label>

              <div class="fields-error-container">
                <!-- Show custom error messages -->
                @if (form.get("signatory")?.errors &&
                !form.get("signatory")?.value) {
                {{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}
                }
              </div>

              <div class="space-y-2">
                @for (singatory of singatoryList; track singatory) {
                <div>
                  <div class="card-edge-cut relative border-blue">
                    <div class="card-body mb-5">
                      <div class="flex gap-5">
                        <input
                          type="radio"
                          [value]="singatory['DC Related Party Name English']"
                          formControlName="signatory"
                          class="h-5 w-5 text-dc-navy border-gray-300 accent-dc-navy mt-1"
                        />
                        <div class="text-dc-navy!">
                          <span class="font-semibold">
                            {{
                              singatory["DC Related Party Name English"]
                            }}</span
                          >
                          <p class="text-dc-navy! py-2">
                            {{ singatory["DC Related Party Name Arabic"] }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
            }
            <!-- <div class="buttons-group mb-5">
              <app-button
                [type]="'button'"
                [label]="'BUTTONS.ADD_NEW_SIGNATORY' | translate"
                classesName="card-edge-cut-white"
                (onBtnClick)="newSignatoryModal = true"
                />
              </div> -->
          </div>
        </section>
        }

        <!-- section for payment method -->
        <section>
          <h1 class="section-heading">
            {{ "SECTION_PAYMENT_METHOD" | translate }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-boolean
                [label]="'PAYMENT_METHOD' | translate"
                [control]="form.get('paymentMethod')!"
                [lovType]="lookupKey.PAYMENT_METHOD"
                [labelKey]="'Value'"
                [valueKey]="'Value'"
                (onSelectionChange)="onPaymentMethodChange($event)"
              />
            </div>
            @if (noAdvancePaymentBalance) {
            <app-validation-message
              [content]="{
                title: 'ALERT.ERROR' | translate,
                message: 'ALERT.NO_ADVANCE_PAYMENT_BALANCE' | translate
              }"
              type="error"
            />
            }
          </div>
        </section>

        <!-- Error Message -->
        @if(technicalErrorMsg){
        <app-validation-message
          [type]="'error'"
          [content]="{
            title: 'VALIDATION_MSG.ERROR' | translate,
            message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate
          }"
          [showbutton]="false"
        ></app-validation-message>
        }

        <div class="btn-section buttons-group">
          @if (showActions && !formSubmitLoader) {
          <app-button
            [type]="'button'"
            [label]="'BUTTONS.NEXT' | translate"
            classesName="btn-edge-cut  btn-width-auto"
            (onBtnClick)="next()"
          />

          <app-button
            [type]="'button'"
            [label]="'BUTTONS.SAVE_CLOSE' | translate"
            classesName="card-edge-cut-white btn-width-auto"
            (onBtnClick)="saveClose()"
          />
          } @if(formSubmitLoader){
          <app-button
            type="button"
            classesName="btn-edge-cut btn-width-auto"
            [label]="'PLEASE_WAIT' | translate"
            [disabled]="true"
          ></app-button>
          }
        </div>
      </form>
      }
    </div>
  </div>
</div>

<!-- Form Completion Progress -->
<div>
  <app-service-progress
    [serviceName]="'ATTESTATION.SERVICE_TITLE' | translate"
    [completePercentage]="formProgress"
  />
</div>

<!-- Add New Signatory Modal -->
@if (newSignatoryModal) {
<div class="dc-modal">
  <div class="dc-modal-container">
    <button
      (click)="newSignatoryModal = false"
      type="button"
      class="modal-x-button"
    >
      <i class="fas fa-close"></i>
    </button>
    <h1 class="section-heading">
      {{ "ATTESTATION.SIGNATORY_TITLE" | translate }}
    </h1>
    <!-- content -->
    <app-add-edit-signatory
      [(isOpen)]="newSignatoryModal"
      (onBtnClick)="(false)"
    />
  </div>
</div>
} @if (successModal) {
<app-sr-submit-success-modal
  [srNumber]="srNumber"
  (onClose)="closeSuccessModal()"
></app-sr-submit-success-modal>
} @if(showNotes) {
<app-notes
  [srNumber]="srNumber"
  [allowSubmit]="true"
  (onClose)="closeNotes($event)"
></app-notes>
}
